export const getRedirectUrl = (redirectURL?: string) =>
    encodeURIComponent(
        redirectURL
            ? redirectURL
            : window.location.pathname +
                  window.location.search +
                  window.location.hash,
    );

export const getReturnUrl = (redirectURL?: string) =>
    `?returnUrl=${getRedirectUrl(redirectURL)}`;
